import { matchPath } from 'react-router-dom';

// Central per-route tab-title table, consumed once in Layout so every routed
// page gets a title with no per-page edits. Pages whose title depends on
// data loaded after mount (CountSession's shelf-count vs receiving flow)
// override this default via their own useDocumentTitle call once that data
// is known; see CountSession.tsx.
const ROUTE_TITLES: Array<{ path: string; title: string[] }> = [
  { path: '/', title: ['Home'] },
  { path: '/today', title: ['Today'] },
  { path: '/inventory', title: ['Inventory', 'Inventory Counts'] },
  { path: '/inventory/variance', title: ['Inventory', 'Inventory Variance'] },
  { path: '/inventory/:id', title: ['Inventory', 'Inventory Counts'] },
  { path: '/my-store', title: ['My Store'] },
  { path: '/paperwork', title: ['Paperwork'] },
  { path: '/comms', title: ['Comms'] },
  { path: '/schedule', title: ['Schedule'] },
  { path: '/resources', title: ['Resources'] },
  { path: '/performance', title: ['Performance'] },
  { path: '/promotions', title: ['Promotions'] },
  { path: '/recognition', title: ['Recognition'] },
  { path: '/pulse', title: ['Pulse'] },
  { path: '/loyalty', title: ['Loyalty'] },
  { path: '/sampling', title: ['Sampling'] },
  { path: '/directory', title: ['Directory'] },
  { path: '/settings', title: ['Settings'] },
  { path: '/changelog', title: ["What's new"] },
];

// Unmatched paths (NotFound, the /chat and /questions redirects) fall back to
// the bare site title via useDocumentTitle's own default.
export function resolveRouteTitle(pathname: string): string[] | undefined {
  return ROUTE_TITLES.find((route) => matchPath({ path: route.path, end: true }, pathname))?.title;
}

// The route pattern a pathname matches, with dynamic segments dropped so a
// detail page maps to its parent (/inventory/123 gives /inventory). Undefined
// when nothing matches.
export function resolveRoutePath(pathname: string): string | undefined {
  const hit = ROUTE_TITLES.find((route) => matchPath({ path: route.path, end: true }, pathname));
  if (!hit) return undefined;
  const base = hit.path.split('/').filter((seg) => seg && !seg.startsWith(':')).join('/');
  return `/${base}`;
}
